<template>
  <div id="app">
    <nav-bar :brandName="marketBrand"
             :brandHref="this.$router.resolve({name: 'sales'}).location"
             :navItems="userNavItems"
             @itemClicked="onItemClick" />
    <public-message
      v-if="userMarket && userMarket.publicMessage"
      :public-message="userMarket.publicMessage.message"
      :public-message-level="userMarket.publicMessage.level"
    />
    <router-view />
    <custom-footer />
  </div>
</template>

<script>
  import NavBar from '@base/components/NavBar.vue'
  import PublicMessage from '@base/components/PublicMessage.vue'
  import CustomFooter from '@base/components/CustomFooter.vue'
  import { APP_NAME, webConfig } from '@base/configs'
  import { mapState } from 'vuex'

  export default {
    name: 'Base',

    components: {
      NavBar,
      PublicMessage,
      CustomFooter
    },

    data () {
      return {
      }
    },

    computed: {
      ...mapState(['userMarket', 'userNavItems']),

      marketBrand () {
        return (this.userMarket && this.userMarket.visualName) ?
          this.userMarket.visualName : this.$t('title.home.company', { appName: APP_NAME })
      }
    },

    created () {
      this.loader = this.$loading.show(this.$_loaderOptions)
      const marketLoaded = this.userMarket ? Promise.resolve() :
        this.$store.dispatch(this.$_actionTypes.GET_USER_MARKET)
      Promise.all([
        this.$store.dispatch(this.$_actionTypes.GET_CUSTOMER_DATA),
        marketLoaded,
      ])
        .then(() => {
          if (!this.userMarket.subaccountFeature)
            return
          return this.$store.dispatch(this.$_actionTypes.GET_CUSTOMER_ACCOUNTS)
        })
        .catch((error) => {
          // A dead token is already handled by the response interceptor.
          this.$_notifyError(error, this)
        })
        .finally(() => {
          this.loader.hide()
        })
    },

    methods: {
      onItemClick (navItem) {
        const urlAfterLogout = `${webConfig.baseURL}/${this.$store.state.marketId}`
        if (navItem.text === this.$t('navigation.general.logout')) {
          this.$store.dispatch(this.$_actionTypes.LOGOUT_CUSTOMER, urlAfterLogout)
        }
      },
    },
  }
</script>

<style scoped>
</style>
